// extracted by mini-css-extract-plugin
export var button = "not-found-page-module--button--PozU8";